import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { gatewayUrl } from '../base/url.gateway';
import { GatewayHttpLoggingService } from '../logging/gateway-http-logging.service';

export interface TransportistaGatewayPostOptions {
  headers?: HttpHeaders;
}

/**
 * Cliente HTTP hacia el API Gateway transportista (POST + manejo de errores centralizado).
 * El header `Authorization: Bearer` lo aplica {@link GatewayBearerInterceptor} si hay token en session.
 */
@Injectable({ providedIn: 'root' })
export class TransportistaGatewayHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly gatewayLog: GatewayHttpLoggingService
  ) {}

  post<T>(
    relativePath: string,
    body: unknown | null | undefined = {},
    options?: TransportistaGatewayPostOptions
  ): Observable<T> {
    const payload = body === undefined ? {} : body;
    const url = gatewayUrl(relativePath);
    let headers = options?.headers || new HttpHeaders();
    if (payload instanceof FormData) {
      // El boundary lo fija el navegador; no enviar application/json (provoca 415 en set-values).
      headers = headers.delete('Content-Type');
    } else if (payload !== null) {
      headers = headers.set('Content-Type', 'application/json');
    }
    return this.http.post<T>(url, payload, { headers }).pipe(
      catchError((err: HttpErrorResponse) => {
        this.gatewayLog.logHttpError(err);
        return throwError(err);
      })
    );
  }
}
